class SameSearchLinks extends HTMLElement {


    connectedCallback() {
        const showMe = window.location.href.includes('seo');
        if (showMe) {
            this.innerHTML =  `<div class="cd-same-search-links-container">
            <span class="cd-same-search-links-title">Вместе с этим также ищут:</span>
            <a class="cd-same-search-links-item" href="/realty-vtorichka-tatarstan/1-komnatnye-kvartiry">Купить 1-комнатную квартиру до 1 млн рублей Татарстан</a>
            <a class="cd-same-search-links-item" href="/realty-vtorichka-tatarstan/2-komnatnye-kvartiry">Купить 2-комнатную квартиру до 1 млн рублей Татарстан</a>
            <a class="cd-same-search-links-item" href="/realty-novostroyki-tatarstan-kazan-sovetskiy/kvartiry">Купить квартиру до 1 млн рублей Советский</a>
            <a class="cd-same-search-links-item" href="/realty-novostroyki-tatarstan-kazan-kirovskiy/kvartiry">Купить квартиру до 1 млн рублей Кировский</a>
        </div>`
        }
    }
};

if (!customElements.get('same-search-links')) customElements.define('same-search-links', SameSearchLinks);
